import { render } from "./DneMarket.vue?vue&type=template&id=2c1f9c6a&scoped=true"
import script from "./DneMarket.vue?vue&type=script&lang=js"
export * from "./DneMarket.vue?vue&type=script&lang=js"

import "./DneMarket.vue?vue&type=style&index=0&id=2c1f9c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1f9c6a"]])

export default __exports__